module.exports = __webpack_public_path__ + "img/2.bcf0c824.png";